import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import HeaderCallout from '../../global/typography/HeaderCallout';

const Text = styled(HeaderCallout)`
  color: ${p => p.theme.color.headerSecondary};
  margin-bottom: 10px;
`;

const Large = styled(Text)`
  flex: 2;
`;

const Small = styled(Text)`
  flex: 1;
`;

const Wrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.color.borderPrimary};
  display: flex;
`;

const HeaderRow = ({ className, showTraining }) => (
  <Wrapper className={className}>
    <Small>Info</Small>
    <Small>Contact</Small>
    {showTraining && <Large>Training Completed</Large>}
  </Wrapper>
);

HeaderRow.propTypes = {
  className: PropTypes.string,
  showTraining: PropTypes.bool
};

export default HeaderRow;
